export default function getService(serviceCodeApi, serviceCodeContentful) {
  if (serviceCodeApi) return serviceCodeApi;

  return serviceCodeContentful;
}
